import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Finances from './pages/Finances';
import Maintenance from './pages/Maintenance';
import Documents from './pages/Documents';
import Voting from './pages/Voting';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';

const theme = createTheme({ palette: { primary: { main: '#1976d2' }, secondary: { main: '#dc004e' } } });

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => (
  <ThemeProvider theme={theme}><CssBaseline /><AuthProvider><Router><Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
      <Route index element={<Dashboard />} />
      <Route path="finances" element={<Finances />} />
      <Route path="maintenance" element={<Maintenance />} />
      <Route path="documents" element={<Documents />} />
      <Route path="voting" element={<Voting />} />
    </Route>
  </Routes></Router></AuthProvider></ThemeProvider>
);
export default App;
